import React from 'react';
import { IMapPoint } from '../../../../models/interfaces/IMapPoint';
import {
	Index,
	WaypointContainer,
	WaypointText,
	WaypointTitle,
} from '../waypointStyles';
import parse from 'html-react-parser';
import { checkString } from '../../../componentUtils';

type WaypointProps = {
	waypoint: IMapPoint;
	index: number;
};
const MinimumWaypoint: React.FC<WaypointProps> = ({ waypoint, index }) => {
	return (
		<WaypointContainer>
			<WaypointText>
				<WaypointTitle>
					<Index>{index + 1}</Index> {waypoint.title}
				</WaypointTitle>
				{parse(checkString(waypoint.short_description))}
			</WaypointText>
		</WaypointContainer>
	);
};

export default MinimumWaypoint;
